// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivityDetails_container__3wnPu","loader":"ActivityDetails_loader__2D-yg"};